<template>
  <div class="bg-logo d-flex">
    <div class="box-add-image">
      <img
        v-if="img !== null"
        :src="urlImg"
        class="img-logo"
        @click="$refs.file.click()"
        @dragover.prevent
        @drop="onDrop"
        alt=""
      />
      <img
        :src="imgDefault"
        alt=""
        class="img-logo"
        v-else
        @click="$refs.file.click()"
        @dragover.prevent
        @drop="onDrop"
      />

      <v-btn class="btn-uploadImg" @click="$refs.file.click()" color="#E9330E"
        ><input
          class="d-none"
          ref="file"
          type="file"
          id="uploadScreens"
          accept="image/*"
          @change="uploadScreen($event)"
        />
        Choose image</v-btn
      >
    </div>

    <v-dialog
      class="image-preview"
      v-model="dialog"
      fullscreen
      hide-overlay
      eager
    >
      <div class="image-preview-wrapper">
        <div class="img-wrap">
          <vue-cropper ref="cropper" v-bind="options" />
        </div>
        <div class="slider-wrapper">
          <range-slider
            class="slider"
            v-bind="sliderOptions"
            v-model="sliderValue"
          >
          </range-slider>
        </div>
        <div class="button-wrapper">
          <v-btn
            color="#E9330E"
            class="btn-cropImg"
            @click="getCropImage"
            v-html="
              $t('register-page.crop-image.btn-save-img', {
                split: '<br />'
              })
            "
          >
            }}</v-btn
          >
          <v-btn
            color="#E9330E"
            class="btn-cropImg"
            @click="closeCrop"
            v-html="
              $t('register-page.crop-image.btn-cancel-img', {
                split: '<br />'
              })
            "
          ></v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper';
import RangeSlider from 'vue-range-slider';
import 'vue-range-slider/dist/vue-range-slider.css';

export default {
  components: {
    VueCropper,
    RangeSlider
  },

  props: {
    img: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      imgDefault:
        'data:image/png;base64,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',
      dialog: false,
      image: null,
      url: null,
      urlImg: this.img,
      sliderOptions: {
        min: 10,
        max: 100,
        step: 1
      },
      sliderValue: 10,
      options: {
        img: this.url,
        full: true,
        canMove: true,
        canScale: false,
        canMoveBox: false,
        fixedBox: true,
        mode: 'cover',
        autoCropWidth: 450,
        autoCropHeight: 450,
        autoCrop: true,
        fixedNumber: [1, 1],
        fixed: true
      }
    };
  },

  methods: {
    async onDrop(event) {
      event.stopPropagation();
      event.preventDefault();
      const files = event.dataTransfer.files;
      await this.checkImg(files[0], this.imgExists);
      await this.validateImgExtension(files[0]);
    },

    async uploadScreen(event) {
      const files = event.target.files;
      await this.checkImg(files[0], this.imgExists);
      await this.validateImgExtension(files[0]);
    },
    checkImg(file, callback) {
      const urlImgCheck = URL.createObjectURL(file);

      const image = new Image();
      image.src = urlImgCheck;
      image.onerror = function () {
        callback(false);
      };
      image.onload = function () {
        callback(true);
      };
    },
    imgExists(exists) {
      if (exists == false) {
        this.dialog = false;
        this.errorImgFormat = true;
      }
    },
    validateImgExtension(file) {
      const validFileExtensions = ['.jpg', '.jpeg', '.bmp', '.tiff', '.png'];
      const fileName = file.name;
      if (fileName.length > 0) {
        let inValid = false;
        for (let j = 0; j < validFileExtensions.length; j++) {
          const curExtension = validFileExtensions[j];
          if (
            fileName
              .substr(fileName.length - curExtension.length)
              .toLowerCase() == curExtension.toLowerCase()
          ) {
            inValid = true;
            this.dialog = true;
            this.createFile(file);
            break;
          }
        }
        if (!inValid) {
          this.errorImgFormat = true;
          file.name = '';
          return false;
        }
      }
    },

    createFile(file) {
      this.url = URL.createObjectURL(file);
      const reader = new FileReader();
      const vm = this;
      reader.onload = function (e) {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    closeCrop() {
      this.$emit('close');
      this.dialog = false;
      this.image = null;
      this.url = null;
      this.sliderValue = 10;
      this.$refs.file.value = null;
    },
    getCropImage(type) {
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob((data) => {
          this.url = window.URL.createObjectURL(data);
          this.dialog = false;
          this.sliderValue = 10;
          this.urlImg = this.url;
          this.$refs.file.value = null;
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.url = data;
          this.dialog = false;
          this.sliderValue = 10;
          this.urlImg = this.url;
          this.$refs.file.value = null;
          this.$emit('getDataImage', this.urlImg);
        });
      }
    },

    reset() {
      this.urlImg = null;
      this.url = null;
      this.image = null;
      this.imageAva = null;
      this.$refs.file.value = null;
      this.$emit('getDataImage', this.urlImg);
    }
  },
  watch: {
    url: function (value) {
      if (value !== null) {
        this.options.img = this.url;
      }
    },
    sliderValue(newVal, oldVal) {
      return this.$refs.cropper.changeScale(newVal - oldVal);
    },
    urlImg: function (val) {
      return val;
    },
    img: function (val) {
      return (this.urlImg = val);
    }
  }
};
</script>

<style scoped lang="scss">
.bg-logo {
  .image-preview {
    width: 100vw !important;
    // background: rgba(0, 0, 0, 0.3) !important;
  }
}

.img-logo {
  display: block;
  width: 100% !important;
  height: 200px !important;
  background: url('../assets/image/img-placeholder.jpg') !important;
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: center;
}

button.btn-uploadImg {
  display: none;
  color: white;
  width: 150px;
  margin-top: 11px;
  margin-right: 10px;
  text-transform: none;
  height: 45px !important;
}
button.btn-cropImg {
  color: white;
  width: 120px;
  margin-right: 10px;
  margin-left: 10px;
  text-transform: none;
  height: 45px !important;
}

.image-preview-wrapper {
  position: absolute;
  background-color: white;
  top: 50%;
  left: 50%;
  width: 800px;
  min-width: 800px;
  min-height: 600px;
  border: solid 1px #eee;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  z-index: 99;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
  overflow-x: hidden;
}

.image-preview {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 800px;
  min-height: 600px;
  border: solid 1px #eee;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  z-index: 99;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
}

.img-wrap {
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 13px;
  margin-bottom: 5px;
  height: 450px;
  width: 450px;
}

.vue-cropper {
  background-image: none !important;
}

.slider-wrapper {
  text-align: center;
}

.slider {
  height: 1px;
  width: 400px !important;
  max-width: 100%;
  padding-top: 20px;
  padding-top: 20px;
  padding-bottom: 43px;
  background-color: transparent;
}

span.range-slider-rail {
  background-color: #a29d9d;
}

span.range-slider-knob {
  background-color: #bfbfbf;
  box-shadow: none;
}

.button-wrapper {
  text-align: center;
  margin-top: 10px;
}

.img-logo {
  display: block;
  width: 100%;
  height: 258px;
  background: url('../assets/image/img-placeholder.jpg') !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position-x: center;
}
button.btn-uploadImg {
  display: none;
  color: white;
  width: 124px;
  margin-top: 11px;
  margin-right: 10px;
}
button.btn-uploadImg.btn-reset {
  margin-right: 0;
}
button.btn-cropImg {
  color: white;
  width: 120px;
  margin-right: 10px;
  margin-left: 10px;
}
.image-preview-wrapper {
  position: absolute;
  background-color: white;
  top: 50%;
  left: 50%;
  width: 800px;
  min-width: 800px;
  min-height: 600px;
  border: solid 1px #eee;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  z-index: 99;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
  overflow-x: hidden;
}
.img-wrap {
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 13px;
  margin-bottom: 5px;
  height: 450px;
  width: 450px;
}
@media only screen and (max-width: 280px) {
  .image-preview-wrapper {
    width: 270px;
    min-width: 270px;
    min-height: 555px;
  }
  .img-wrap {
    width: 265px;
    height: 265px;
  }
  button.btn-cropImg {
    margin-right: 5px;
    margin-left: 5px;
  }
}
@media only screen and (max-width: 320px) {
  .img-logo {
    width: 100%;
    height: 238px;
  }
  button.btn-uploadImg {
    width: 114px;
  }
}
@media only screen and (max-width: 450px) and (min-width: 281px) {
  .image-preview-wrapper {
    width: 300px;
    min-width: 300px;
    min-height: 555px;
  }
  .img-wrap {
    width: 300px;
    height: 300px;
  }
}
@media only screen and (max-width: 768px) and (min-width: 451px) {
  .image-preview-wrapper {
    width: 700px;
    min-width: 700px;
    min-height: 600px;
  }
}
.image-preview {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 800px;
  min-height: 600px;
  border: solid 1px #eee;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  z-index: 99;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
}
.vue-cropper {
  background-image: none !important;
}
.slider-wrapper {
  text-align: center;
}
.slider {
  height: 1px;
  width: 280px !important;
  max-width: 100%;
  padding-top: 20px;
  padding-bottom: 43px;
  background-color: transparent;
}
span.range-slider-rail {
  background-color: #a29d9d;
}
span.range-slider-knob {
  background-color: #bfbfbf;
  box-shadow: none;
}
.button-wrapper {
  text-align: center;
  margin-top: 10px;
}
.alert-box {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  margin-bottom: 0;
  text-align: center;
}
.closeError {
  margin-top: 10px;
  margin-right: 35px;
  color: #000000;
}
</style>
